<template>
  <span class="print-view">
    <div class="btn-group float-right">
      <vs-button class="mx-1 my-1" type="border" @click="onClickPrint">Print & Download</vs-button>
    </div>
    <page id="printDiv" size="A4">
      <div class="label-sheet">

        <div class="label dynamic">
          <div class="label-left section">
            <h4 class="title GarrettFat">A BRAVER FLAVOUR</h4>
            <div class="field-group">
              <p class="meet-us">Meet us:</p>
              <p class="address Montserrat">Innovation House<br>Abex Road<br>Newbury<br>RG14 5EY</p>
            </div>
            <div class="field-group">
              <p class="contact-us">Contact us:</p>
              <p class="contact-info Montserrat">sales@itstaste.com</p>
            </div>
            <div class="field-group">
              <p class="find-out">Find out more:</p>
              <p class="website Montserrat">www.itstaste.com</p>
            </div>
          </div>
          <div class="label-center section">
            <img id="logo" src="@/assets/images/logo/its_logo_horizontal_black.jpg" alt="Logo" />
            <p class="product ">{{ Label_name }}</p>
            <p class="code ">{{ formulation_code }}</p>
          </div>
          <div class="label-right section">
            <div class="right-top">
              <div class="field-group">
                <p class="declaration-title">Declaration:</p>
                <p class="declaration-value">{{ classification }}</p>
              </div>
              <div class="field-group">
                <p class="best-before-title">Best Before:</p>
                <p class="best-before-value">{{ best_before_date }}</p>
              </div>
              <div class="field-group">
                <p class="max-dosage-title">Max Dosage:</p>
                <p class="max-dosage-value">{{ max_dosage }}</p>
              </div>
              <div class="field-group">
                <p class="sample-text Montserrat">Sample for<br>evaluation <br> purposes only</p>
              </div>
            </div>

            <div class="image-list">
              <div v-for="(img, index) in label_images" :key="'image' + index">
                <img class="ul-icon" :src="'https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/UL-Images/' + img"
                  alt="" />
              </div>
            </div>

          </div>

        </div>
      </div>
    </page>
  </span>
</template>


<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const UlRepository = RepositoryFactory.get('ul');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { Printd } from "printd";
import vSelect from 'vue-select'
import fontFile from '@/assets/fonts/garet-fat.ttf'

const CustomerRepository = RepositoryFactory.get('customer')

function initialState() {
  return {
    best_before_date: '',
    formulation_code: '',
    Label_name: '',
    max_dosage: '',
    classification: '',
    labelData: [],
    groupedLabelData: [],
    label_images: [],
  }
}

export default {
  name: "SampleOrderItemLabelPrintView",
  data() {
    return initialState()
  },
  async mounted() {
    this.best_before_date = this.$route.query.best_before_date
    this.formulation_code = this.$route.query.formulation_code
    this.Label_name = this.$route.query.name
    this.max_dosage = this.$route.query.dosage
    this.classification = this.$route.query.classification
    await this.getLabelData()

    this.$nextTick(() => {
      this.adjustFontSize()
    })
  },
  methods: {
    // async getSampleOrderDetails() {
    //   const { data } = (await CustomerRepository.getSampleOrder(this.SOId)).data;
    //   this.orderDetails = data;
    //   if(this.orderDetails.pack_size) {
    //     this.print_pack_size = Number(this.orderDetails.pack_size).toFixed(4)
    //     this.pack_size_options.push({name: `Print ${this.print_pack_size}Kg version (from so)`, value: this.print_pack_size})
    //   }
    // },
    async getLabelData() {
      try {
        const { data } = await UlRepository.getFormulationLabel(this.formulation_code.replace('-', ''));
        this.labelData = data.data
        this.labelData = this.labelData.filter((x) => {
          return !(x.data.match(/^&+$/) || x.data === "")
        })
        this.groupedLabelData = _.groupBy(this.labelData, label => label.data_code);
        this.label_images = this.labelData.filter((x) => x.data.includes('.png')).map((y) => y.data)
        for (let i of Array(4 - this.label_images.length).keys()) {
          this.label_images.push('no-symbol.png')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },

    adjustFontSize() {
      const productElements = document.querySelectorAll('.product')

      productElements.forEach(element => {
        if (!element.textContent.trim()) return

        const textLength = element.textContent.length
        let screenFontSize, printFontSize

        // Screen sizes and corresponding print sizes
        if (textLength <= 15) {
          screenFontSize = '30px'
          printFontSize = '5px'
        } else if (textLength <= 25) {
          screenFontSize = '20px'
          printFontSize = '4px'
        } else if (textLength <= 35) {
          screenFontSize = '16px'
          printFontSize = '3px'
        } else if (textLength <= 50) {
          screenFontSize = '14px'
          printFontSize = '2px'
        } else {
          screenFontSize = '12px'
          printFontSize = '1.5px'
        }

        // Set screen font size
        element.style.fontSize = screenFontSize

        // Add CSS custom properties for print
        element.style.setProperty('--print-font-size', printFontSize)
        element.classList.add('dynamic-font')
      })
    },

    // async generateDate() {
    //   if (this.orderDetails.formulation_stock && this.orderDetails.formulation_stock.length > 0) {
    //     this.best_before = this.orderDetails.formulation_stock[0].expiration_date
    //   }

    //   // For sample orders, we'll use the formulation code as the customer item code by default
    //   this.customer_item_code = this.orderDetails.formulation_code
    // },
    // onClickPrint() {
    //   this.adjustFontSize()
    //   window.print()
    // },


    onClickPrint() {
      this.adjustFontSize();

      document.fonts.ready.then(() => {

        const printWindow = window.open('', '_blank', 'width=800,height=600');

        const labelContent = document.getElementById('printDiv').innerHTML;
        const fontUrl = fontFile;

        const printDocument = `
<!DOCTYPE html>
<html>
<head>
<title>Label Print</title>

<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet">

<style>

@font-face {
  font-family: "GarrettFat";
  src: url("${fontUrl}") format("truetype");
}

@page {
  size: 110mm 34mm;
  margin: 0;
}

*{
  margin:0;
  padding:0;
  box-sizing:border-box;
}

body{
  width:110mm;
  height:34mm;
  font-family:'Montserrat', Arial, sans-serif;
  background:white;
  overflow:hidden;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.GarrettFat{
  font-family:'GarrettFat', Arial, sans-serif;
}

.label-sheet{
  display:flex;
  flex-direction:column;
  padding:0;
  margin:0;
}

.label{
  display:flex;
  flex-direction:row;
  width:110mm;
  height:34mm;
  overflow:hidden;

  background-image:url('https://m-support.s3.eu-west-2.amazonaws.com/support-app/attachments/1772636187_ULDkxRIzYA.jpg');
  background-size:cover;
  background-repeat:no-repeat;
  background-position:center;

  padding-left:3mm;
}

.section{
  flex:1;
  margin:2mm;
  padding:2mm;
  border-radius:8px;
  background:white;
  border:0.5px solid #000;
  overflow:hidden;
}

.label-left{
  flex:1;
  display:flex;
  flex-direction:column;
  align-items:center;
}

.label-center{
  flex:2;
  text-align:center;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
}

.label-right{
  flex:2;
  font-size:5px;
  display:flex;
  flex-direction:column;
}

.right-top{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:2mm;
}

.image-list{
  display:grid;
  grid-template-columns:repeat(4,1fr);
  width:100%;
  margin-top: 2mm;
}

.image-list img{
  width:100%;
  height:auto;
  object-fit:contain;
}

.title{
  font-size:8px;
  font-weight:bold;
  margin-bottom:1mm;
  text-align:center;
  line-height: 1 !important;
}

.meet-us,
.contact-us,
.find-out,
.declaration-title,
.max-dosage-title,
.best-before-title{
  color:#e76ba8;
  font-weight:bold;
  margin:0 0 0.5mm 0;
  font-size:6px;
}

.address,
.contact-info,
.website,
.declaration-value,
.max-dosage-value,
.best-before-value{
  margin:0;
  font-size:6px;
  line-height:1.1;
}

.field-group{
  margin-bottom:1mm;
  display:flex;
  flex-direction:column;
  align-items:center;
  text-align:center;
}

#logo{
  max-width:70%;
  max-height:12mm;
  height:auto;
  width:auto;
  margin-bottom:1mm;
  object-fit:contain;
}

.product{
  margin:1mm 0;
  line-height:1.0;
  text-align:center;
  word-wrap:break-word;
}

.product.dynamic-font{
  font-size:var(--print-font-size);
}

.product:not(.dynamic-font){
  font-size:5px;
}

.code{
  font-size:9px;
  margin-top:1mm;
  font-weight:bold;
}

.sample-text{
  margin-top:1mm;
  font-size:6px;
  line-height:1.1;
  text-align:center;
}

</style>
</head>

<body>

${labelContent}

<script>

function adjustFontSize() {
  document.querySelectorAll('.product').forEach(el => {

    if (!el.textContent.trim()) return;

    const len = el.textContent.length;

    let size;

    if (len <= 15) size = '15px'
    else if (len <= 25) size = '13px'
    else if (len <= 35) size = '11px'
    else if (len <= 50) size = '10px'
    else size = '8px'

    el.style.fontSize = size
    el.classList.add('dynamic-font')

  })
}

document.fonts.ready.then(adjustFontSize)

<\/script>

</body>
</html>
`;

        printWindow.document.write(printDocument);
        printWindow.document.close();

        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };

      });
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');

@font-face {
  font-family: "GarrettFat";
  src: url("~@/assets/fonts/garet-fat.ttf") format("woff2");
  font-weight: normal;
  font-style: normal;
}

body {
  background-color: white !important;
}

page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.1cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  color: #000;
}

h4 {
  color: #000 !important;
}

.GarrettFat {
  font-family: 'GarrettFat'
}

.Montserrat {
  font-family: 'Montserrat' !important;
}

page[size="A4"] {
  width: 21cm;
  height: fit-content;
}


.label-sheet {
  display: flex;
  flex-direction: column;
  gap: 8mm;
  padding: 10mm;
  align-items: flex-start;
}


.label {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url('https://m-support.s3.eu-west-2.amazonaws.com/support-app/attachments/1772636187_ULDkxRIzYA.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.section {
  flex: 1;
  margin: 8px;
  padding: 12px;
  border-radius: 15px;
  background: white;
  backdrop-filter: blur(10px);
  box-sizing: border-box;
  border: 2px solid #000;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}


.label-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
}

.label-center {
  flex: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.label-right {
  flex: 2;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.right-top {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.image-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  margin: 0;
  padding: 0;
}

.image-list div {
  margin: 0;
  padding: 0;
}

.image-list img {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0;
  padding: 0;
}



.label .title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #000;
  text-align: center;
  width: 100%;
}


.meet-us,
.contact-us,
.find-out {
  color: #e76ba8;
  font-weight: bold !important;
  margin: 0 0 2px 0;
  font-size: 13px;
}

.address,
.contact-info,
.website {
  margin: 0;
  line-height: 1.2;
  font-size: 13px;
}


#logo {
  max-width: 100%;
  max-height: 70px;
  height: auto;
  width: auto;
  margin-bottom: 10px;
  object-fit: contain;
}

.product {
  // font-weight: bold;
  font-size: 20px;
  margin: 8px 0;
  color: #000;
  line-height: 1.1;
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.code {
  font-size: 30px;
  margin-top: 4px;
  color: #000;
  font-weight: bold;
}


.field-group {
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.declaration-title,
.max-dosage-title,
.best-before-title {
  color: #e76ba8;
  font-weight: bold;
  margin: 0 0 2px 0;
  font-size: 15px;
}

.declaration-value,
.max-dosage-value,
.best-before-value {
  margin: 0;
  font-size: 15px;
  // font-weight: bold;
}

.sample-text {
  margin-top: 0px;
  font-size: 15px;
  line-height: 1.2;
  text-align: right;
}


.reference {
  opacity: 0.85;
}

// @media print {
//   @page {
//     size: A4;
//     margin: 0;
//   }


//   .label {
//     width: 110mm !important;
//     height: 34mm !important;
//     font-size: 9px;
//     overflow: hidden;
//     display: flex;
//     flex-direction: row;
//     // border: 2px solid #000;
//     padding-left: 3mm !important;
//   }


//   .section {
//     margin: 2mm !important;
//     padding: 2mm !important;
//     border-radius: 8px !important;
//     background: rgba(255, 255, 255, 0.95) !important;
//     // border: 1px solid #000 !important;
//     border: hidden;
//     box-shadow: none !important;
//     overflow: hidden !important;
//     box-sizing: border-box !important;
//   }


//   .label-left   { 
//     visibility: hidden !important;
//     flex: 0 0 20mm !important; 
//     width: 20mm !important;
//     min-width: 20mm !important;
//     max-width: 20mm !important;
//   }
//   .label-left * {
//     visibility: hidden !important;
//   }
//   .label-center { 
//     flex: 0 0 35mm !important; 
//     width: 35mm !important;
//     min-width: 35mm !important;
//     max-width: 35mm !important;
//   }
//   .label-right  { 
//     flex: 0 0 20mm !important; 
//     width: 20mm !important;
//     min-width: 20mm !important;
//     max-width: 20mm !important;
//   }
//   .label-last   { 
//     flex: 0 0 11mm !important; 
//     width: 11mm !important;
//     min-width: 11mm !important;
//     max-width: 11mm !important;
//   }


//   #logo {
//     max-width: 95% !important;
//     max-height: 13mm !important;
//     height: auto !important;
//     width: auto !important;
//     margin-bottom: 1mm !important;
//     margin-top: 2mm;
//     object-fit: contain !important;
//   }

//   #logo,
//   .declaration-title,
//   .max-dosage-title, 
//   .best-before-title {
//     visibility: hidden !important;
//   }

//   .title {
//     font-size: 8px !important;
//     margin-bottom: 1mm !important;
//     line-height: 1.1 !important;
//   }

//   .meet-us, .contact-us, .find-out, 
//   .declaration-title, .max-dosage-title, .best-before-title {
//     font-size: 6px !important;
//   }

//   .address, .contact-info, .website, 
//   .declaration-value, .max-dosage-value, .best-before-value {
//     font-size: 5px !important;
//     line-height: 1.1 !important;
//     margin: 0 !important;
//   }

//   .product {
//     margin: 1mm 0 !important;
//     line-height: 1.0 !important;
//     word-wrap: break-word !important;
//     overflow-wrap: break-word !important;
//     hyphens: auto !important;
//     text-align: center !important;
//     max-width: 100% !important;
//     box-sizing: border-box !important;
//   }


//   .product.dynamic-font {
//     font-size: var(--print-font-size) !important;
//   }

//   .product:not(.dynamic-font) {
//     font-size: 5px !important;
//   }

//   .code {
//     font-size: 7px !important;
//     margin-top: 1mm !important;
//   }

//   .sample-text {
//     font-size: 5px !important;
//     margin-top: 2mm !important;
//     line-height: 1.1 !important;
//   }

//   .field-group {
//     margin-bottom: 1.5mm !important;
//   }


//   .label.reference {
//     display: none !important;
//   }

//   .label-last img.responsive {
//     max-width: 80% !important;
//     max-height: 15mm !important;
//     width: auto !important;
//     height: auto !important;
//     object-fit: contain !important;
//   }



//   .label-last img.responsive {
//     max-width: 80% !important;
//     max-height: 15mm !important;
//     width: auto !important;
//     height: auto !important;
//     object-fit: contain !important;
//   }


//   .print-view * {
//     visibility: hidden;
//   }
//   #printDiv,
//   #printDiv * {
//     visibility: visible;
//   }
//   #printDiv {
//     position: absolute;
//     left: 0;
//     top: 0;
//     box-shadow: none;
//   }
// }</style>